var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,2.45c15.19,0,27.55,12.36,27.55,27.55S45.19,57.55,30,57.55S2.45,45.19,2.45,30S14.81,2.45,30,2.45 M30,1.5 C14.26,1.5,1.5,14.26,1.5,30S14.26,58.5,30,58.5S58.5,45.74,58.5,30S45.74,1.5,30,1.5L30,1.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,5.3c13.62,0,24.7,11.08,24.7,24.7S43.62,54.7,30,54.7S5.3,43.62,5.3,30S16.38,5.3,30,5.3 M30,4.35 C15.84,4.35,4.35,15.84,4.35,30S15.84,55.65,30,55.65S55.65,44.16,55.65,30S44.16,4.35,30,4.35L30,4.35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCircle);
export default __webpack_public_path__ + "static/media/double_circle.d0df738e7338d099db9a2203cd810241.svg";
export { ForwardRef as ReactComponent };